import styled from 'styled-components'

const Grid = styled.div`
  display: flex;
  width: 100%;
`

export default Grid
